var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4286",
    "data-name": "Group 4286",
    transform: "translate(-18 -26)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(18 26)",
    fill: "#e5e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M16.5,18.5a6.25,6.25,0,1,0-6.25-6.25A6.248,6.248,0,0,0,16.5,18.5Zm0,1.125c-4.172,0-12.5,2.094-12.5,6.25V29H29V25.875C29,21.719,20.672,19.625,16.5,19.625Z",
    transform: "translate(32 37)",
    fill: "#b2b2b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIco);
export default __webpack_public_path__ + "static/media/User_ico.1ff517c7a5b371eab29eeddd14b58d1a.svg";
export { ForwardRef as ReactComponent };